/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorWorkspaceUserDto } from '../../models/vendor-workspace-user-dto';

export interface VendorWorkspaceUserControllerFindUsersByWorkspaceId$Params {

/**
 * 입점사 ID
 */
  id: string;
}

export function vendorWorkspaceUserControllerFindUsersByWorkspaceId(http: HttpClient, rootUrl: string, params: VendorWorkspaceUserControllerFindUsersByWorkspaceId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorWorkspaceUserDto>>> {
  const rb = new RequestBuilder(rootUrl, vendorWorkspaceUserControllerFindUsersByWorkspaceId.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VendorWorkspaceUserDto>>;
    })
  );
}

vendorWorkspaceUserControllerFindUsersByWorkspaceId.PATH = '/api/vendorWorkspaceUser/{id}/users';
